import svang from '../assets/9 aff/4 sväng-small.jpg';
import svang_small from '../assets/9 aff/4 sväng-small.jpg';
import bakatvolt from '../assets/9 aff/2 bakåtvolt-small.jpg';
import bakatvolt_small from '../assets/9 aff/2 bakåtvolt-small.jpg';
import delta from '../assets/9 aff/3 delta2-small.jpg';
import delta_small from '../assets/9 aff/3 delta2-small.jpg';
import { useState } from 'react';

import { Article, DocsHeader, DocsHeading, DocsIntro, Image, Section, SectionHeader } from '../extra/Components';
import { Question, Questionary } from '../extra/Quiz';

import {
    faListUl,
} from "@fortawesome/free-solid-svg-icons";

const affQuiz = [
    Question.oneQ("På vilken höjd slutar man göra nya övningar?", "2000m", ["1500m", "1600m", "1400m", "1800m"]),
    Question.oneQ("På vilken höjd drar man sin fallskärm?", "1800m", ["1500m", "1600m", "1400m", "2000m"]),
    Question.order("Hotellcheck", ["Check in", "Få tumme upp", "Check ut", "Få skak i selen", "Key-a", "hoppa"]),
];

const affMoment = <Section id="moment" name="Moment">
    <SectionHeader>Moment</SectionHeader>
    <dl>
        <dt>Hotellcheck</dt>
        <dd>Checkar in och får tumme upp från instruktör, checkar ut och får ett skak i selen av den
            instruktören.</dd>
        <dt>Key</dt>
        <dd>Rörelse som timear uthoppet. Ut in hopp.</dd>
        <dt>Uthopp</dt>
        <dd>Hotellcheck följt av key.</dd>
        <dt>Observationscirkel</dt>
        <dd>Kollar heading, höjd, vänster instruktör och får tecken, höger instruktör och få tecken.
        </dd>
        <dt>Dummy drag</dt>
        <dd>Simulerat drag. Känner pilothandtaget är på rätt plats och att man hittar det.</dd>
        <dt>Drag</dt>
        <dd>Vink, svank, ta, dra</dd>
        <dt>Framåtåkning</dt>
        <dd>Man drar in armarna och sträcker på benen för att åka framåt. För att bromsa gör man det
            motsatta. Sträcker på armarna och drar in benen.</dd>
        <dt>360 graders sväng</dt>
        <dd>Samma som sväng men man ser inte sin heading förrän slutet av svängen. Tittar åt sidan
            medan man svänger och bromsar när man får syn på det man har som ny heading.</dd>
    </dl>
    <h3>Sväng</h3>
    <Image image={svang} imageSmall={svang_small} alt="Sväng" />

    <p>En sväng består utav fyra moment. Nya heading. Starta sväng. Stoppa sväng. Höjdkoll. Ny
        heading gör man med blicken. Man startar en sväng genom att trycka ner armbågen på sidan
        man vill svänga mot. Stoppa sväng är bara att svänga åt andra hållet.</p>
    <h3>Bakåtvolt</h3>

    <Image image={bakatvolt} imageSmall={bakatvolt_small} alt="Bakåtvolt" />

    <p>Sträck ut armarna fullt framåt. Dra in benen till magen. Tryck armarna neråt. Ge det nån
        sekund att komma runt. Stabilisera. Bakåtvolten har inget ändamål i sig själv utan är bara
        till för att orsaka instabilitet.</p>
    <h3>Delta track</h3>
    <Image image={delta} imageSmall={delta_small} alt="Delta track" />

    <p>Track är ett samlingsnamn på ställningar man håller för att förflytta sig horisontellt. Track
        används framför allt för att separera från andra hoppare inför drag. Under kursen trackar
        dina instruktörer bort från dig efter du dragit. I och med det används för att separera är
        att man håller en heading medan man trackar extra viktigt. Det spelar ingen roll om man
        trackar dubbelt så snabbt om man gör det i en cirkel. Ta sig bort från ursprungspunkten är
        hela syftet. Den stabilaste sortens track kallas delta track och är den vi övar på under aff
        programmet.</p>
    <p>Delta track gör man genom att medan man behåller svanken sträcka ut benen och därefter
        sträcka armarna utåt 45 grader bakåt. Under utbildningen kör vi trackar i 5 sekunder. Man
        räknar till "5000". Man börjar sträcka på benen när man startar. Når full
        utsträckning med armarna också på 3000. Håller under 4000 och återgår på 5000. Man gör det
        i lugna rörelser. Plötsliga rörelser leder lätt till instabilitet. Man trackar inte längre
        än så i ett sträck för man kan inte se sin höjdmätare medan man trackar.</p>
</Section>;

const affQuizSection = <Section id="affquiz" name="Quiz">
    <SectionHeader>Quiz, aff</SectionHeader>
    <Questionary questions={affQuiz} />
</Section>;

const Aff = ({ setSection, setArticle }) => (
    <Article name="AFF" icon={faListUl} id="aff" setArticle={setArticle} setSection={setSection}>
        <DocsHeader>
            <DocsHeading note="Updaterad: 2022-07-13">AFF</DocsHeading>
            <DocsIntro>
                <p>AFF utbildningsplan</p>
            </DocsIntro>
            <p>Det här kapitlet är inte lönt att läsa i förväg utan innehåller referensprogram för alla program
                för att kunna kolla när det är dags att förbereda respektive hopp. Läs relevanta hopp senast
                kvällen innan det är dags.</p>
        </DocsHeader>

        <Section id="program" name="Program">
            <SectionHeader>Program</SectionHeader>
            <p>Frifallets prioriteter går före alla program och alla krav. Drar man inte sin fallskärm i tid
                så är man underkänd på hoppet. Varje gång du tittar på höjdmätaren repetera höjden till dig
                själv och är den under 2000m avbryt programmet och förbered för drag. Alla drag under
                utbildningen påbörjas på 1800m. Man kollar höjdmätaren minst mellan varje moment.</p>
            <p>Instruktörerna är duktiga flygare men det finns alltid en möjlighet att de av olika
                anledningar finns där bredvid en i frifallet. På de två första hoppen om man förlorar båda
                instruktörer och det finns någon tveksamhet om ens stabilitet eller höjdmedvetenhet drar man
                sin fallskärm på en gång. Försvinner den ena instruktören fortsätter man sitt program och
                följer kvarvarande instruktörs instruktioner.</p>
            <p>På senare hopp har man bevisat att man kan dra sin fallskärm och tillåts då att fortsätta
                sitt program om det känns bra. Dessa program innehåller också fler och fler frisläppta
                moment där man kan tappa bort instruktören. Ligger man still är de sannolikt snart framför
                en.</p>
            <p>Under samtliga hopp tillsammans med instruktörer kommer instruktörerna "säkra" ens drag. Det
                innebär att de håller en i sidan av riggens sele och hjälper till att stabilisera drag och
                se till att fallskärmen dras. I de tidiga hoppen håller instruktörerna i hela tiden. I de
                senare hoppen är det möjligt att instruktören ger tecken att svänga åt sidan så de får sina
                handtag till sig. Gör man inte det flyger de runt till sina grepp. Då ligger man bara still
                och håller koll på höjden.
            </p>
            <br />

            <AffPages />
        </Section>
        {affMoment}
        {affQuizSection}
    </Article>
);

const AffPages = ({ }) => {
    let [page, setPage] = useState(0);

    return (<>
        <nav className="docs-nav navbar " aria-label="Aff programs navigation">
            <ul className="pagination pl-0">
                {affLevels.map((v, i) => (<li key={i} className={"page-item " + (page == i ? "active" : "")}><button className="page-link"
                    onClick={e => setPage(i)}
                >{(i + 1)}</button></li>)
                )}
            </ul>
        </nav>
        {affLevels[page]}
    </>)

}

const Aff1 = ({ }) => (
    <AffLevel
        name="AFF 1 - Dra din fallskärm"
        program={["Uthopp",
            "Observationscirkel",
            "3 Dummy drag",
            "Observationscirkel",
            "Beroende på höjd fri tid. Kolla höjden regelbundet",
            "Drag på 1800m"]}
        underCanopy={["Flyg hemåt.",
            "När du är i lekområdet testa hur fallskärmen beter sig när man flärar.",
            " Landa enligt prioriteringar."]}
        goals={["Testa på frifall och dra sin egen fallskärm."]}
        criteria={["Dra sin egen fallskärm på rätt höjd.",
            "Reagerar på tecken."]}
    >
        <p>Hopp med två instruktörer. Här lägger vi all fokus på att ha koll på höjden och kunna dra
            sin egen fallskärm.</p>
    </AffLevel>
);

const Aff2 = ({ }) => (
    <AffLevel
        name="AFF 2 - Svängar"
        program={["Uthopp",
            "Observationscirkel",
            "2 Dummy drag",
            "Sväng 90 grader",
            "Sväng 90 grader tillbaka",
            "Framåtåkning i 3 sekunder",
            "Drag på 1800m"]}
        underCanopy={["Flyg hemåt.",
            "När du är i lekområdet testa hur fallskärmen beter sig när man flärar.",
            " Landa enligt prioriteringar."]}
        goals={["Förstå svängar.",
            "Förstå framåtåkning.",
            "Bättre fallställning."]}
        criteria={["Dra sin egen fallskärm på rätt höjd.",
            "Reagerar på tecken.",
            "Starta och stoppa en sväng."]}

    >
        <p>Hopp med två instruktörer. Testa på rörelserna för svängar.</p>
    </AffLevel>);

const Aff3 = ({ }) => (
    <AffLevel
        name="AFF 3 - Frisläppt flygning"
        program={[
            "Uthopp",
            "Observationscirkel",
            "1 Dummy drag",
            "Eventuellt slå ihop hälarna två gånger för att känna att benen är symmetriska",
            "Ligg still och håll heading på horisonten. Styr emot om du svänger",
            "Instruktörerna släpper när det är stabilt",
            "Drag på 1800m"
        ]}
        underCanopy={[
            "När du är i lekområdet testa testa en 360 graders svängar."
        ]}
        goals={[
            "Stabil fallställning",
            "Heading-kontroll"
        ]}
        criteria={[
            "Dra sin egen fallskärm på rätt höjd.",
            "Reagerar på tecken.",
            "Faller frisläppt i minst 10 sekunder.",
            "Kontrollerar sin heading.",
            "Landing enligt prioriteringar."
        ]}
    >
        <p>Hopp med två instruktörer. Det här hoppet är det första där man får testa på att falla
            helt ostört av grepp.
            Instruktörerna ligger bredvid och kan vara lite svåra att se så från och med det här
            hoppet fortsätter vi programmet om vi inte ser eller känner de.</p>
    </AffLevel>);

const Aff4 = ({ }) => (
    <AffLevel
        name="AFF 4 - Frisläppta svängar"
        program={["Uthopp",
            "Observationscirkel",
            "1 Dummy drag",
            "Instruktören släpper",
            "90 grader sväng till instruktören",
            "90 grader sväng bort från instruktören åt det håll hen pekar",
            "90 grader sväng till instruktören",
            "Framåtåkning till instruktören, instruktören tar grepp.",
            "Vidare svängar på kommando",
            "Slut på 2000m",
            "Drag på 1800m"]}
        underCanopy={["Testa att göra bromsade svängar åt vardera håll."]}
        goals={["Stabil fallställning",
            "Heading-kontroll",
            "Svängar"]}
        criteria={[
            "Dra sin egen fallskärm på rätt höjd.",
            "Reagerar på tecken.",
            "Faller stabilt frisläppt.",
            "Kontrollerar sin heading.",
            "Minst en en kontrollerad 90 grader sväng.",
            "Landing enligt prioriteringar."
        ]}

    >
        <p>Första hoppet med bara en instruktör. Uthoppet sker på samma sätt som tidigare men utan
            ena instruktören. Kvarvarande instruktör väljer själv om hen vill stå innanför eller
            utanför. Beroende på var vi är i planet inför uthopp kan man få testa att spotta.</p>
    </AffLevel>);

const Aff5 = ({ }) => (
    <AffLevel
        name="AFF 5 - 360 svängar"
        program={[
            "Ogreppat uthopp",
            "Observationscirkel",
            "1 Dummy drag",
            "Instruktören lägger sig framför och ger kommando.",
            "360 graders sväng åt instruerat håll.",
            "360 graders sväng åt andra hållet.",
            "Framåtåkning till instruktören, instruktören tar grepp.",
            "Slut på 2000m",
            "Drag på 1800m"
        ]}
        underCanopy={[
            "Lossa ena styrhandtaget innan det andra. Detta simulerar en toggle fire. Se om du kan svänga emot svängen som blir genom att styra med de bakre bärremmarna.",
            " Efter du testat lossa andra styrhandtaget och fortsätt som vanligt."
        ]}
        goals={[
            "Stabil fallställning.",
            "Heading-kontroll.",
            "Självständigt uthopp.",
            "360 Svängar.",
        ]}
        criteria={[
            "Dra sin egen fallskärm på rätt höjd.",
            "Reagerar på tecken.",
            "Faller stabilt.",
            "Minst en en kontrollerad 360 grader sväng.",
            "Genomför framåtåkning.",
            "Landing enligt prioriteringar."
        ]}
    >
        <p>En instruktör. Första hoppet där instruktören inte håller i en. 360 svängar innebär att
            man inte ser sin nya heading när man börjar svänga. Man tittar 90 grader åt sidan och
            bromsar svängen när man får syn på instruktören.</p>
        <p>I det här hoppet är det krav på att åka framåt till instruktören till skillnad från förra
            hoppet. Beroende på höjd kan instruktören välja att att ge tecken att åka fram till hen
            efter bara en 360 sväng om den är godkänd.</p>
    </AffLevel>);

const Aff6 = ({ }) => (
    <AffLevel name="AFF 6 - Stabilitet"
        program={["Ogreppat <b>dyk</b> uthopp, huvudet neråt och inifrån planet. Blir det ostabilt är det del av syftet med hoppet. Blir det stabilt är det ett bra uthopp att kunna.",
            "Observationscirkel.",
            "1 Dummy drag.",
            "På nick från instruktören bakåtvolt.",
            "Återfå stabilitet.",
            "Instruktören ger riktning.",
            "Delta-track i fem sekunder åt given riktning.",
            "Ifall återstående tid svängar på instruktörs kommando.",
            "Slut på 2000m",
            "Drag på 1800m"]}
        underCanopy={["På höjd testa att flyga på halv broms",
            "På höjd testa att flyga på bara bakre bärremmar",
            "Se hur punkten som inte rör sig flyttar sig relativt bromsningarna."
        ]}
        goals={["Kunna snabbt bli stabil och hålla heading efter en störning.",
            "Självständigt dyk exit.",
            "Bli ostabil och hitta stabilitet igen.",
            "Delta-track."]}
        criteria={["Dra sin egen fallskärm på rätt höjd.",
            "Reagerar på tecken.",
            "Återfå stabilitet efter bakåtvolt.",
            "Delta-track mot en heading. ",
            "Tar sig framåt med sin track.",
            "Landing enligt prioriteringar."]}
    >
        <p>En instruktör. Målet i hopp sex är att göra eleven ostabil och sen låta den göra sig
            själv stabil igen. Primära verktyget för att bli stabil är att svanka. Primära verktyget
            för att göra eleven ostabil är att låta hen försöka göra en bakåtvolt. Efter det testar
            vi på en delta-track för att förflytta oss. I uthoppet står instruktören ur vägen på
            kamera steget.</p>
    </AffLevel>);

const Aff7 = ({ }) => (
    <AffLevel
        name="AFF 7 - Examinationshopp"
        program={[
            "Ogreppat <b>dyk</b> uthopp",
            "1 Dummy drag",
            "Bakåtvolt när redo.",
            "Återfå stabilitet",
            "360 graders sväng åt höger.",
            "360 graders sväng åt vänster.",
            "Instruktören ger riktning för delta track.",
            "Delta-track i fem sekunder åt given riktning.",
            "Ifall återstående tid svängar på instruktörs kommando",
            "Slut på 2000m",
            "Drag på 1800m"
        ]}
        underCanopy={[
            "Testa att svänga genom att dra i främre bärremmar.",
            "Testa att svänga genom att hänga snett i selen."
        ]}
        goals={[
            "Kunna snabbt bli stabil och hålla heading efter en störning.",
            "Självständigt dyk exit.",
            "Bli ostabil och hitta stabilitet igen.",
            "Visa upp kontrollerade svängar.",
            "Delta-track."
        ]}
        criteria={[
            "Dra sin egen fallskärm på rätt höjd.",
            "Reagerar på tecken.",
            "Återfå stabilitet efter bakåtvolt.",
            "Minst en 360 sväng.",
            "Delta-track mot en heading. ",
            "Tar sig framåt med sin track.",
            "Landing enligt prioriteringar."
        ]}
    >
        <p>En instruktör. Det här hoppet testar igenom färdigheterna vi övat på i de tidigare
            hoppen. Eventuellt ändrar instruktören om programmet för att fokusera på svagare område
            om man redan uppvisat god färdighet sen innan. I uthoppet står instruktören ur vägen på
            kamera steget.</p>
        <p>Om det är ont om höjd kan instruktören hoppa över ena 360 grader svängen till förmån för
            att hinna delta tracken.</p>
    </AffLevel>);

const Aff8 = ({ }) => (
    <AffLevel
        name="AFF 8 - Ensamhopp"
        program={[
            "2 Dummy drag.",
            "Testa att hålla högerhanden på pilothandtaget och styra heading med vänsterhanden",
            "Om tid över öva svängar.",
            "Slut på 2000m",
            "Drag på 1800m",
        ]}
        underCanopy={[
            "Efter eget tycke."
        ]}
        goals={[
            "Överleva ett fallskärmshopp självständigt."
        ]}
        criteria={[
            "Dra sin egen fallskärm på rätt höjd.",
            "Landing enligt prioriteringar."
        ]}
    >
        <p>Första hoppet helt ensam. En instruktör kommer fortfarande att kontrollera ens utrustning
            i flygplanet och ge klartecken när det är klart att hoppa. Dessa hopp är till för att
            öva på svagheter inför sista hoppet som är från lägre höjd.</p>
        <p>En lämplig övning är också att flyga sin kropp i dragställning. Det gör man genom att
            föra bak högerhanden och greppa piloten. Man ligger kvar i den ställningen och använder
            sin andra arm för att styra. Detta är nyttigt för att stoppa snurrade när man drar.</p>
    </AffLevel>);

const Aff9 = ({ }) => (
    <AffLevel
        name="AFF 9 - Ensamhopp 2"
        program={[
            "2 Dummy drag.",
            "Delta track i fem sekunder.",
            "180 graders sväng.",
            "Delta track i fem sekunder.",
            "180 graders sväng.",
            "Upprepa ovan om höjd till övers.",
            "Slut på 2000m",
            "Drag på 1800m"
        ]}
        underCanopy={[
            "Efter eget tycke."
        ]}
        goals={[
            "Överleva ett fallskärmshopp självständigt."
        ]}
        criteria={[
            "Dra sin egen fallskärm på rätt höjd.",
            "Landing enligt prioriteringar."
        ]}
    >
        <p>Nästa ensamhopp. En instruktör kommer fortfarande att kontrollera ens utrustning
            i flygplanet och ge klartecken när det är klart att hoppa. Dessa hopp är till för att
            öva på svagheter inför sista hoppet som är från lägre höjd.</p>
        <p>Vad man övar på bestämmer man i samråd med sin instruktör. Lämplig är att öva vidare på
            delta track. Kör ena hållet 5 sekunder och sedan 180 graders sväng följt av tracking
            tillbaka.</p>
    </AffLevel>);

const Aff10 = ({ }) => (
    <AffLevel
        name="AFF - Låghopp"
        program={[
            "Bli stabil",
            "Drag"
        ]}
        underCanopy={[
            "Efter eget tycke."
        ]}
        goals={[
            "Klara av ett låtsas-nödhopp."
        ]}
        criteria={[
            "Dra sin egen fallskärm inom tio sekunder från uthoppet.",
            "Landing enligt prioriteringar."
        ]}
    >
        <p>Låghoppet måste inte vara sista hoppet under utbildningen. Det kan vara antingen hopp 9
            eller 10. Syftet med låghoppet är att simulera uthoppshöjden för ett nödhopp. Proceduren
            är ut, bli stabil och dra fallskärmen.</p>
    </AffLevel>);

const AffLevel = ({ name, program, goals, criteria, children, underCanopy }) => (
    <div key={name}>
        <h4 className="section-heading">{name}</h4>
        {children}
        <h5 className="section-heading">Frifall</h5>
        <ol>
            {program.map((p, i) => (<li key={i}>{p}</li>))}
        </ol>
        <h5 className="section-heading">Under fallskärm</h5>
        <ul>
            {underCanopy.map((p, i) => (<li key={i}>{p}</li>))}
        </ul>
        <h5 className="section-heading">Mål</h5>
        <ul>
            {goals.map((p, i) => (<li key={i}>{p}</li>))}
        </ul>
        <h5 className="section-heading">Krav</h5>
        <ul>
            {criteria.map((p, i) => (<li key={i}>{p}</li>))}
        </ul>
    </div>
);

let affLevels = [
    (<Aff1 />),
    (<Aff2 />),
    (<Aff3 />),
    (<Aff4 />),
    (<Aff5 />),
    (<Aff6 />),
    (<Aff7 />),
    (<Aff8 />),
    (<Aff9 />),
    (<Aff10 />)]

export { Aff, affQuiz, affLevels, AffLevel, affMoment, affQuizSection };